import { cn } from "@/libs/utils";

export function IrPageLayout({ children }: any) {
  return (
    <div className={cn("ir-page-layout mx-auto h-full w-full bg-white")}>
      {children}
    </div>
  );
}
